import React, { useState } from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { Button, Text, TextInput } from '@leverege/ui-elements';
import { EditorUtil } from '@leverege/ui-attributes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LinkCellRenderer(props) {
  const {
    context,
    editable,
    variant,
    style,
    value,
    usage,
    object,
    ...options
  } = props;
  const [editing, setEditing] = useState(usage === 'form');
  const delegate = context?.clientProps?.delegate;
  const vnt = variant ? `${variant}|linkTable` : 'linkTable';
  if (!editing) {
    if (delegate?.isGotoAllowed?.()) {
      return /*#__PURE__*/_jsx(Button, {
        onClick: evt => {
          if (editable) {
            setEditing(true);
          } else {
            GlobalState.dispatch(delegate.goTo(object.id));
          }
        },
        variant: vnt,
        children: value
      });
    }
    if (!editable) {
      return /*#__PURE__*/_jsx(Text, {
        variant: vnt,
        children: value
      });
    }
  }
  return /*#__PURE__*/_jsx(TextInput, {
    autoFocus: true,
    style: style // This makes it follow colorizers
    ,
    variant: EditorUtil.getVariant(usage, 'string', 'editor'),
    ...options,
    onDoubleClick: stopProp,
    onBlur: () => {
      if (usage !== 'form') {
        setEditing(false);
      }
    },
    value: value
  });
}
function stopProp(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}